import type { BoxShopSalesFormValues, BoxShopSendEmailFormValues } from "@/modules/boxShop/form/boxShopFormik"
import type { BoxShopSalesInputDto, BoxShopSalesMailDto } from "@/modules/boxShop/gateway/boxShopSalesApiDto"

export const BOX_SHOP_SALES_MAX_QUANTITY = 999

export const BoxShopSalesEntity = {
  fromFormikToInputDto(values: BoxShopSalesFormValues): BoxShopSalesInputDto {
    return {
      outOfBand: values.outOfBand,
      items: values.items.map((item) => ({
        id: item.id,
        quantity: item.quantity,
      })),
      coupon: values.coupon?.value === 0 ? null : values.coupon,
      userId: values.userId,
    }
  },

  fromFormikToMailDto(saleId: string, values: BoxShopSendEmailFormValues): BoxShopSalesMailDto {
    return {
      id: saleId,
      userId: values.userId,
      email: values.email,
    }
  },
}
